import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import { connect } from 'react-redux';
import Order from '../components/Order';
import * as orderActions from '../actions/order';
import * as toursActions from '../actions/tours';

//Data that needs to be called before rendering the component
//This is used for server side rending via the fetchComponentDataBeforeRending() method


function mapStateToProps(state) {
 //console.log(state);

  return {
    tour: state.tours.tour,
    departure: state.tours.departure,
    user: state.user,
    user_id: state.user.id,
    order: state.order
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toursActions: bindActionCreators(toursActions, dispatch),
    orderActions: bindActionCreators(orderActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Order);


// WEBPACK FOOTER //
// ./src/common/containers/OrderPage.js